import { render, staticRenderFns } from "./ProgressMonitoringBlock.vue?vue&type=template&id=c4146940&scoped=true"
import script from "./ProgressMonitoringBlock.vue?vue&type=script&lang=js"
export * from "./ProgressMonitoringBlock.vue?vue&type=script&lang=js"
import style0 from "./ProgressMonitoringBlock.vue?vue&type=style&index=0&id=c4146940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4146940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VMenu})
